import React from 'react';
import LoaderContainer from './elements';

const Loader = ({ size, inverse, alignSelf, marginT, marginR, marginB, marginL }) => (
  <LoaderContainer
    alignSelf={alignSelf}
    className="lds-ring"
    size={size}
    marginT={marginT}
    marginR={marginR}
    marginB={marginB}
    marginL={marginL}
    inverse={inverse}
  >
    <div />
    <div />
    <div />
    <div />
  </LoaderContainer>
);

export default Loader;
